module.exports = __webpack_public_path__ + "static/media/profile.d143134c.jpeg";